module.exports = __webpack_public_path__ + "static/img/electric-gray.dcaeeb12.png";